import { render, staticRenderFns } from "./statrgyArticleForm.vue?vue&type=template&id=3a23e9ec&scoped=true"
import script from "./statrgyArticleForm.vue?vue&type=script&lang=js"
export * from "./statrgyArticleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23e9ec",
  null
  
)

export default component.exports